import axios from "axios";
import { Apis } from "../util/Apis";

export const DEFAULT_CURRENCY_CONFIG = {
  currency: "SOLES",
  symbol: "S/"
};

export function normalizeCurrencyConfig(config = {}, fallbackConfig = DEFAULT_CURRENCY_CONFIG) {
  const fallback = fallbackConfig || DEFAULT_CURRENCY_CONFIG;

  return {
    currency: config?.currency || config?.currencyIso || fallback.currency,
    symbol: config?.symbol || config?.currencySymbol || fallback.symbol
  };
}

export function persistCurrencyConfig(config = DEFAULT_CURRENCY_CONFIG) {
  localStorage.setItem("globalConf", JSON.stringify(config));
  return config;
}

export async function syncSalaCurrencyConfig(salaId, fallbackConfig = DEFAULT_CURRENCY_CONFIG) {
  const fallback = normalizeCurrencyConfig(fallbackConfig);

  if (!salaId) {
    return persistCurrencyConfig(fallback);
  }

  try {
    const response = await axios.get(`${Apis.SALAS}/salas-config`, {
      headers: {
        "X-Sala-ID": salaId
      },
      timeout: 10000
    });

    return persistCurrencyConfig(normalizeCurrencyConfig(response.data, fallback));
  } catch (error) {
    return persistCurrencyConfig(fallback);
  }
}

export function getCurrencyConfig() {
  const lsConfig = localStorage.getItem("globalConf")

  if (lsConfig === undefined || lsConfig === null) {
    return DEFAULT_CURRENCY_CONFIG
  }

  let result
  try {
    result = JSON.parse(lsConfig)
  } catch (e) {
    return DEFAULT_CURRENCY_CONFIG
  }


  return normalizeCurrencyConfig(result)
}
